import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import SentimentAnalytics from '../pages/extra-pages/Sentiment-analytics';
import { AuthGuard } from '../sections/auth/AuthGuard';
import CronPage from '../pages/cron-configuration/cronConfigurationForm';

// render- Dashboard
const DashboardCheck = Loadable(lazy(() => import('pages/dashboard')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const ReviewListPage = Loadable(lazy(() => import('pages/extra-pages/review-list-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/', element: <AuthGuard />, children: [{
    path: '/',
    element: <DashboardLayout />,
    children: [
      {
        path: '/',
        element: <DashboardCheck />
      },
      {
        path: 'dashboard',
        children: [
          {
            path: '',
            element: <DashboardCheck />
          }
        ]
      },

      {
        path: 'typography',
        element: <Typography />
      },
      {
        path: 'color',
        element: <Color />
      },
      {
        path: 'shadow',
        element: <Shadow />
      },
      {
        path: 'sample-page',
        element: <SamplePage />
      },
      {
        path: 'review-list',
        element: <ReviewListPage />
    },
    {
      path: 'sentiment-analytics',
      element: <SentimentAnalytics />
      },
      {
        path: 'cron-create',
        element: <CronPage />
      }
    ]
  }]
};

export default MainRoutes;
